import logdown from 'logdown';
import React from 'react';
// @ts-ignore
import EllipsisText from 'react-ellipsis-text';
import { connect } from 'react-redux';
import { returntypeof } from 'react-redux-typescript';
import { RouteProps, RouterProps } from 'react-router';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Dispatch, bindActionCreators } from 'redux';

import { State } from '../../reducers';
import { closeMonitoringSystems, deleteMonitoringSystem, editMonitoringSystem, saveMonitoringSystem } from '../monitoring-systems';
import MonitoringSystemsList from '../monitoring-systems/MonitoringSystemsList';
import { DraggableModal } from '../utils';

const logger = logdown('component:MonitoringSystemsModal');

class Component extends React.Component<Props, unknown> {
  public render() {
    return (
      <DraggableModal
        id="monitoring-systems-information-modal"
        data-testid="monitoring-systems-information-modal"
        size="lg"
        scrollable
        style={{ maxWidth: '1600px', width: '80%' }}
        isOpen={this.props.monitoringSystemsDialog.isOpen}
        toggle={this.close.bind(this)}
        onUnmountWhileOpen={this.close.bind(this)}
      >
        <ModalHeader data-testid="monitoring-systems-modal-header" toggle={this.close.bind(this)}>
          <EllipsisText className="stakeholder-monitoringsystems-header" text={`Monitoring Systems`} length={75} />
        </ModalHeader>
        {/* The body holds the padding and never scrolls; the box inside it is the only thing that does, in both
            directions. That keeps the padding visible at every scroll position, instead of the table sliding under it,
            and lets the table's sticky header stay put while the rows move. */}
        {/* The body holds the padding and does not scroll: the table inside it does, and only its rows, so the
            buttons above it and its pager stay where they are. */}
        <ModalBody className="d-flex flex-column" style={{ padding: '1rem 1.25rem', overflow: 'hidden' }}>
          {/* No chooser at the top: the pagination bar at the bottom of the table already carries Show/Hide Columns,
              and the top one renders over the header row inside a modal. */}
          <MonitoringSystemsList showTopManageHiddenCols={false} tableMaxHeight="100%" {...this.props} />
        </ModalBody>
        <ModalFooter>
          <Button
            className="monitoring-systems-cancel-button"
            data-testid="monitoring-systems-modal-cancel-button"
            color="secondary"
            onClick={this.close.bind(this)}
          >
            Close
          </Button>
        </ModalFooter>
      </DraggableModal>
    );
  }

  protected close(e?: any) {
    e?.preventDefault();
    // if (this.props.stakeHolderNotificationSending.workLogs.isSome()) {
    //   return this.props.closeAlertStakeholderNotification();
    // }
    return this.props.closeMonitoringSystems();
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      closeMonitoringSystems,
      deleteMonitoringSystem,
      saveMonitoringSystem,
      editMonitoringSystem,
    },
    dispatch,
  );

const mapStateToProps = (state: State) => ({
  user: state.user,
  monitoringSystemsDialog: state.monitoringSystemsDialog,
  monitoringSystemsListing: state.monitoringSystemsListing,
  monitoringSystemEditing: state.monitoringSystemEditing,
  monitoringSystemDeleting: state.monitoringSystemDeleting,
  monitoringSystemSaving: state.monitoringSystemSaving,
  monitoringSystemIncidentInformationDialog: state.monitoringSystemIncidentInformationDialog,
  sitesGroupsListing: state.sitesGroupsListing,
  sitesListing: state.sitesListing,
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps & RouteProps & RouterProps;

// @ts-ignore
export default connect<typeof stateProps, typeof dispatchProps, any>(mapStateToProps, mapDispatchToProps)(Component);
